import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dropdown from 'react-toolbox/lib/dropdown'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'

import styles from './styles.scss'

const AcceptDropdown = ({source, value, onChange}) => {
  return (
    <Dropdown
      auto
      source={source}
      theme={styles}
      label={T.translate('containers.approval.approvalDialog.acceptDialog.label')}
      value={value}
      onChange={onChange}
    />
  )
}

const withStyle = CSSModules(styles)
export default withStyle(AcceptDropdown)
